import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift, PawPrint } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-blue-400" data-id="element-94" />,
    color: 'bg-blue-500/10 border-blue-500/20',
    title: 'TOMO 1 — Guía Esencial Primeros Pasos',
    subtitle: 'La base para empezar con calma y confianza',
    desc: 'Prepará su llegada, armá rutinas simples y entendé qué necesita tu cachorro desde el primer día para sentirse seguro en casa.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-emerald-400" data-id="element-95" />,
    color: 'bg-emerald-500/10 border-emerald-500/20',
    title: 'TOMO 2 — Educación y Comportamiento',
    subtitle: 'Hábitos que construyen una convivencia feliz',
    desc: 'Aprendé a enseñar límites, evitar accidentes de pis y acompañar conductas saludables sin gritos ni métodos confusos.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-400" data-id="element-96" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 3 — Alimentación Saludable',
    subtitle: 'Nutrición para cada etapa de crecimiento',
    desc: 'Orientación práctica para elegir, servir y ajustar su alimentación según peso, edad y necesidades diarias.'
  }, {
    icon: <Library className="w-8 h-8 text-rose-400" data-id="element-97" />,
    color: 'bg-rose-500/10 border-rose-500/20',
    title: 'TOMO 4 — Salud y Prevención',
    subtitle: 'Cuidados atentos para verlo crecer bien',
    desc: 'Reconocé señales importantes, organizá controles y sabé cuándo actuar para cuidar su bienestar con tranquilidad.'
  }, {
    icon: <Notebook className="w-8 h-8 text-purple-400" data-id="element-98" />,
    color: 'bg-purple-500/10 border-purple-500/20',
    title: 'TOMO 5 — Actividades y Juegos',
    subtitle: 'Energía bien canalizada, todos los días',
    desc: 'Juegos y estímulos pensados para su edad que fortalecen el vínculo, reducen el aburrimiento y mejoran su conducta.'
  }, {
    icon: <BookType className="w-8 h-8 text-orange-400" data-id="element-99" />,
    color: 'bg-orange-500/10 border-orange-500/20',
    title: 'TOMO 6 — Solución a Problemas',
    subtitle: 'Respuestas claras para los desafíos cotidianos',
    desc: 'Abordá mordidas, llantos, ansiedad y malos hábitos con estrategias concretas para recuperar la armonía en casa.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-100">
      <div className="max-w-5xl mx-auto" data-id="element-101">
        <div className="text-center mb-10" data-id="element-102">
          <Badge variant="success" className="mb-4" data-id="element-103">
            PUNTO DIGITAL™ — KIT COMPLETO PARA TU CACHORRO
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-104">
            6 Tomos + 5 Bonos — Todo para sus primeros meses
          </h2>
          <p className="text-xl text-slate-400" data-id="element-105">
            Guías prácticas — Rutinas claras — Acompañamiento completo
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-106">
            <span data-id="element-107">Primeros pasos</span>{' '}
            <span className="text-slate-600" data-id="element-108">→</span>
            <span data-id="element-109">Educación</span> <span className="text-slate-600" data-id="element-110">→</span>
            <span data-id="element-111">Alimentación</span> <span className="text-slate-600" data-id="element-112">→</span>
            <span data-id="element-113">Salud</span> <span className="text-slate-600" data-id="element-114">→</span>
            <span data-id="element-115">Juegos</span> <span className="text-slate-600" data-id="element-116">→</span>
            <span data-id="element-117">Soluciones</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-118">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-119">
            <PawPrint className="w-8 h-8 text-brand-400" data-id="element-120" /> 6 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-121">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-122">
                <div className="flex items-start gap-4" data-id="element-123">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-124">
                    {tomo.icon}
                  </div>
                  <div data-id="element-125">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-126">
                      {tomo.title}
                    </h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-127">
                      {tomo.subtitle}
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-128">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-129">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-130">
            Cada tomo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-131">
            {['Guías claras con pasos simples para aplicar en casa', 'Rutinas adaptadas a cada etapa de crecimiento', 'Señales para entender mejor su comportamiento', 'Ejercicios y prácticas de entrenamiento positivo', 'Recomendaciones de bienestar para el día a día', 'Alternativas para distintos ritmos de familia', 'Planillas y recursos listos para imprimir', '100% pensado para familias argentinas'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-132">
                <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-133" />
                <span className="text-slate-300" data-id="element-134">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'Calculadora de Porciones según Peso/Edad',
    desc: 'Una referencia simple para ajustar sus porciones diarias a medida que crece.',
    value: '$8.000'
  }, {
    title: 'Lista de lo que nunca debe morder o comer',
    desc: 'Identificá objetos y alimentos que pueden ponerlo en riesgo dentro y fuera de casa.',
    value: '$8.000'
  }, {
    title: '100 juegos de estimulación para tu cachorro',
    desc: 'Ideas listas para activar su mente, canalizar energía y reforzar el vínculo cada día.',
    value: '$9.000'
  }, {
    title: 'Calendario de Entrenamiento 30 Días',
    desc: 'Una rutina diaria y fácil de seguir para crear hábitos sin sentirte abrumado.',
    value: '$8.000'
  }, {
    title: 'Guía de Emergencias: Cuándo ir al veterinario',
    desc: 'Señales claras para saber cuándo pedir ayuda profesional y actuar a tiempo.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        <div className="text-center mb-8" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-138">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-139" />5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-140">
            Siempre incluidos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-8" data-id="element-141">
          {bonuses.map((bono, i) => <Card key={i} className={`relative overflow-hidden group hover:border-brand-500/50 transition-colors lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''}`} data-id="element-142">
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-143">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-144">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-145">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-146">
                <span className="line-through text-slate-500 text-sm" data-id="element-147">
                  Valor {bono.value}
                </span>
                <span className="text-emerald-400 font-bold" data-id="element-148">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-gradient-to-r from-brand-900/50 to-emerald-900/50 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-149">
          <p className="text-slate-300 mb-2" data-id="element-150">Valor total bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-151">
            $51.000
          </p>
          <p className="text-2xl font-bold text-emerald-400" data-id="element-152">
            → GRATIS con tu kit completo
          </p>
        </div>
      </div>
    </section>;
}